const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'libs/common_web/src/components/PageErrorBoundary/translations.ts';
import { defineMessages } from '@cistec/common_web/utils/intlUtils';

declare const __RELATIVE_SOURCE_FILE__: string;

export default defineMessages(
    {
        unexpectedError: 'Unerwarteter Fehler',
        restartApp: 'Die Applikation muss neu gestartet werden.',
    },
    __RELATIVE_SOURCE_FILE__
);
